import { type CSSProperties, Suspense } from "react";
import { lazyRetry } from "../../lib/lazy-retry";
import type { StepDeckItem } from "./gtm-step-deck";
import { HeroRow } from "./hero-row";
import { IntelShell } from "./intel-shell";
import { IntelSectionNav } from "./intel-top-nav";
import { C } from "./tokens";

// The demand-trends charts are the heavy panel (D3 + recharts); keep 1.1's
// headline strip instant and lazy-load the charts below it.
const ThreeCharts = lazyRetry(() => import("./three-charts").then((m) => ({ default: m.ThreeCharts })));

// Italic accent word inside the serif head — Intelligence's blue hue.
const ACCENT: CSSProperties = { fontStyle: "italic", color: C.accentItalic };

// 1.1 has the vertical room to show both reads at once, so it drops the
// within-section rail: the headline metric strip and the demand-trend charts
// live in one scroll under a single editorial header.
export function GlobalSection({ subtitle: _subtitle }: { subtitle: string }) {
  return (
    <IntelShell id="global">
      <IntelSectionNav
        steps={[] as StepDeckItem[]}
        active={0}
        onSelect={() => {}}
        n="1.1"
        kicker="Global demand"
        head={
          <>
            The state of global <em style={ACCENT}>tourism</em>
          </>
        }
        lede="Arrivals, Receipts, Spend, and ALOS"
      />

      <div
        data-row-anchor="headline"
        data-row-label="Headline metrics"
        className="src-enter"
        style={{ "--d": 2 } as CSSProperties}
      >
        <HeroRow />
      </div>

      <div
        data-row-anchor="trends"
        data-row-label="Demand trends"
        className="src-enter"
        style={{ "--d": 3, marginTop: 22 } as CSSProperties}
      >
        <Suspense fallback={<div style={{ minHeight: 320 }} />}>
          <ThreeCharts frosted />
        </Suspense>
      </div>
    </IntelShell>
  );
}
